<script lang="ts" setup>
    import BaseButton from '@/components/BaseButton.vue';
    import BaseIcon from '@/components/BaseIcon.vue';
    import useConfigStore from '@/store/config.store';
    import { storeToRefs } from 'pinia';

    const { fZoom } = storeToRefs(useConfigStore());

    function zoomIn() {
        fZoom.value *= 1.1;
    }
    function zoomOut() {
        fZoom.value *= 0.9;
    }
</script>

<template>
    <div class="bg-bg border-border relative w-full grow overflow-hidden border">
        <slot />
        <div class="absolute bottom-2 right-2 z-30 flex flex-col gap-3">
            <BaseButton
                class="pointer-events-auto h-10 w-10"
                @click="zoomIn"
            >
                <span class="sr-only">
                    {{ $t('zoom_out') }}
                </span>
                <BaseIcon
                    size="lg"
                    name="MagnifyingGlassPlusIcon"
                />
            </BaseButton>
            <BaseButton
                class="pointer-events-auto h-10 w-10"
                @click="zoomOut"
            >
                <span class="sr-only">
                    {{ $t('zoom_out') }}
                </span>
                <BaseIcon
                    size="lg"
                    name="MagnifyingGlassMinusIcon"
                />
            </BaseButton>
        </div>
    </div>
</template>
